// Single editable description rendered in the site footer.
// Persisted as one row in /static-pages (slug = FOOTER_DESCRIPTION_SLUG),
// matching how FAQ / Terms / Privacy reuse the same backend table.

export const FOOTER_DESCRIPTION_SLUG = 'footer';

export interface FooterDescriptionContent {
  id?: number | null;
  title: string;
  slug: string;
  updatedAt: string | Date | null;
  description: string;
}

/** Wire payload — backend rejects unknown keys (forbidNonWhitelisted). */
export type FooterDescriptionWrite = {
  title: string;
  slug: string;
  description: string;
};

export const EMPTY_FOOTER_DESCRIPTION: FooterDescriptionContent = {
  id: null,
  title: '',
  slug: '',
  description: '',
  updatedAt: null,
};

export const EMPTY_FOOTER_DESCRIPTION_WRITE: FooterDescriptionWrite = {
  title: '',
  slug: '',
  description: '',
};
